import styled from "styled-components"
import {
  validColor,
  darkBorder,
  darkFontColor,
  darkBackground,
} from "./helpers"

export const StyledSelectWrapper = styled.div`
  /* display: ${({ hidden }) => (hidden ? "none;" : "inline-block;")} */
  ${({ hidden }) =>
    hidden
      ? `
        display: none;
        height: 0;
        width: 0;
    `
      : `
        display: inline-block;
    `}
  width: ${({ half }) => (half ? "50%;" : "100%;")}
    float: ${({ half }) => (half ? "left;" : "inherit;")}
    margin: .8rem 0;
  position: relative;

  & label {
    width: 100%;
    font-size: 14px;
    font-family: "EFCircularWeb-Book";
    line-height: 1;
    color: #2b2b2b;
    padding: 0 1.6rem 0 0;
    display: flex;
    justify-content: space-between;
    color: ${({ isDark }) => darkFontColor(isDark)};
    @media (max-width: 1024px) {
      font-size: 12px;
      padding: 0 1.3rem 0 0;
    }

    & span {
      color: #ee6160;
      font-family: "EFCircularWeb-Book";
    }
  }
  ${(props) =>
    props.loading &&
    `
        opacity: .5;
        pointer-events: none;
    `}
`

export const StyledSelect = styled.div`
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  overflow: hidden;
  align-items: center;
  background: ${({ isDark }) => darkBackground(isDark)};
  border-radius: 4px;
  margin: 0.4rem 0 0 0;
  height: 100%;
  width: 100%;
  position: relative;
  border: 1px solid ${({ isDark }) => darkBorder(isDark)};
  background: blue;
  z-index: 2;

  & select {
    width: 100%;
    min-height: 54px;
    font-family: "EFCircularWeb-Book";
    line-height: 1.2;
    padding: 1.6rem;
    font-size: 16px;
    margin: 0;
    -webkit-appearance: none;
    @media (max-width: 1024px) {
      min-height: 44px;
      font-size: 14px;
      padding: 1.3rem;
    }
  }
`
export const StyledSelectIcons = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  pointer-events: none;
  top: 0;
  height: 100%;

  & svg {
    height: 16px;
    width: 16px;
    margin: 0 8px 0 0;
  }
`

export const StyledTooltipWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 42px;
  z-index: 10;
`

export const StyledTooltip = styled.div`
  background: white;
  padding: 4px 8px;
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
  border-radius: 2px;
  visibility: hidden;
  display: hidden;

  p {
    font-size: 14px;
    color: ${(props) => props.theme.colors.darkGrey80};
    display: none;
  }
`

export const StyledHover = styled.div`
  cursor: pointer;
  height: 18px;
  margin-top: -9px;

  & > i {
    top: 0 !important;
    right: 0 !important;
  }
  :hover {
    height: 100%;

    & i {
      display: none;
    }
    ${StyledTooltip} {
      background: #ededed;
      margin-left: 50px;
      visibility: visible;
      opacity: 1;
      display: block;
      transition-delay: 50ms;
      transition: opacity 0.1s ease-out;
      -moz-transition: opacity 0.1s ease-out;
      -webkit-transition: opacity 0.1s ease-out;
      -o-transition: opacity 0.1s ease-out;
      cursor: auto;

      p {
        display: block;
      }
    }
  }
`
